import React, { useState,useEffect } from "react";
import { Link,useParams } from "react-router-dom";
import axios from 'axios';

import { useRecoilState } from "recoil";
import { BranchMenus } from "../../components/recoil/atoms/Menus";

import HeaderBranchTitle from "../components/includes/HeaderBranchTitle";
import EvaluationOptions from "../components/analysis/EvaluationOptions";

import { ChangeSimpleDateString,PassedMonths,GetChildrenState } from "../../components/common/Common";
import "../../css/style.css";

//보강수업설정
const MamaMonteDetail = () => {
  const { clc_idx } = useParams();
  //LoginAftclass02IconerCheckLogin(2);  //로그인 상태 점검\
  const [varBranchMenus,setBranchMenus] = useRecoilState(BranchMenus);

  const [varClassChildrenInfo,setClassChildrenInfo] = useState({}); //원생/클라스 정보
  const [varStudyList,setStudyList] = useState([]); //마마몽떼 교육 목록

  const [varStudySubjectList,setStudySubjectList] = useState([]); //마마몽떼 교육의 제목 목록
  const [varSelectStudySubjectList,setSelectStudySubjectList] = useState([]);
  const [varStudyEvaluationList,setStudyEvaluationList] = useState([]); //마마몽떼 교육의 평가 목록

  const [varStudyIndex,setStudyIndex] = useState(0);  //평가할 교육번호
  const [varEvaluationIndex,setEvaluationIndex] = useState(0);  //평가번호

  //평가할 원생/클래스정보 호출
  const GetClassList = async() => {
    const sendData = {clc_idx:clc_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_childrens_mamamonte`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const childrenInfo = datas.results[0];
        //원생 및 클래스 수업 정보 
        setClassChildrenInfo(childrenInfo);
        
        //평가 항목 저장 배열
        setStudyList(datas.studys); //마마몽뗴 수업 목록 - 6~8,...
        setStudySubjectList(datas.subjects);  //제목목록 - 뒤집기...
        setStudyEvaluationList(datas.checks); //평가항목 - ROLLING OVER 뒤집기,...

        //평가를 이미 했는지 - 평가번호 --> 0이면 미평가
        if(childrenInfo.clc_ev_idx > 0) {
          setEvaluationIndex(childrenInfo.clc_ev_idx);  
          setStudyIndex(childrenInfo.ev_vt_idx);
        } 
      }
    });
  }

  //평가서 읽기
  const GetEvaluationInformation = async(subjectList) => {
    const sendData = {ev_idx:varEvaluationIndex};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_get_evaluation_mamamonte`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const evaluationList = datas.results;
        for(var i=0; i < subjectList.length; i++) {
          let checks = subjectList[i].checks;
          for(var j=0; j < checks.length; j++) {
            let items = checks[j];
            let vtc_idx = items.vtc_idx;
            let findIndex = evaluationList.findIndex(el=>el.evl_vtc_idx === vtc_idx);
            if(findIndex >= 0) {
              items.evl_score = evaluationList[findIndex].evl_score;
            }
          }
        }
        console.log(subjectList);
        //평가항목 재설정
        setSelectStudySubjectList(subjectList);
      }
    });
  }

  //최초실행부
  useEffect(() => {
    console.log(varBranchMenus);
    setBranchMenus({showMenu:true,gotoMain:1});
    GetClassList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //평가할 교육번호 지정 --> 해당교육에 대한 평가제목/항목 배열 작성
  useEffect(() => {
    //평가제목 배열
    const subjectList = varStudySubjectList.filter(el=>el.vt_idx === varStudyIndex);
    for(var i=0; i<subjectList.length; i++) {
      let vts_idx = subjectList[i].vts_idx;
      //평가 제목별 항목 배열
      let evals = varStudyEvaluationList.filter(el=>el.vt_idx===varStudyIndex && el.vts_idx === vts_idx);
      subjectList[i].checks = evals;
    }
    //평가항목 재설정
    if(varEvaluationIndex === 0) {
      setSelectStudySubjectList(subjectList);
    } else {
      GetEvaluationInformation(subjectList);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [varStudyIndex]);

  //평가할 수업 선택시
  const onChangeStudyHandler = async(e) => {
    const vt_idx = Number(e.currentTarget.value);
    if(varStudyIndex !== vt_idx) {
      setEvaluationIndex(0);
    }
    setStudyIndex(vt_idx);
  }

  //옵션선택
  const onChangeOptionHandler = (e,vts_idx,vtc_idx) => {
    //선택된 평가번호
    const evl_score = Number(e.currentTarget.value);
    //console.log(vts_idx,evl_score);

    //평가된 평가제목번호
    let copyList = [...varSelectStudySubjectList];
    const findIndex1 = copyList.findIndex(el=>el.vts_idx === vts_idx);

    //평가된 평가옵션번호
    const findIndex2 = copyList[findIndex1].checks.findIndex(el=>el.vtc_idx===vtc_idx);

    //전체배열에서 평가된 값을 저장
    copyList[findIndex1].checks[findIndex2].evl_score = evl_score;
    //console.log(copyList[findIndex1].checks[findIndex2]);
    setSelectStudySubjectList(copyList);
  }

  //저장
  const onUpdateMamMonteHandler = async(e) => {
    if(!window.confirm('MDT 발달 진도표를 저장하시겠습니까?')) return false;

    const sendData = {clc_idx:clc_idx,vt_idx:varStudyIndex,ev_idx:varClassChildrenInfo.clc_ev_idx};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_evaluation_mamamonte`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      if(datas.retvalue === 1) {
        const ev_idx = datas.ev_idx;
        UpdateMamMonteOptions(ev_idx);
      } else {
        alert(datas.message);
      }
    });
  }
  const UpdateMamMonteOptions = async(ev_idx) => {
    const sendData = {clc_idx:clc_idx,ev_idx:ev_idx,dataList:varSelectStudySubjectList};
    console.log(sendData);
    await axios.post(`${process.env.REACT_APP_HOST}/branch_update_evaluation_mamamonte_options`,sendData).then((res) => {
      const datas = res.data;
      console.log(datas);
      alert(datas.message);
      if(datas.retvalue === 1) {
        //navigate('/Branch/AnalysisSet');
        window.history.back();
      }
    });
  }

  return (
    <div className="vh-content">
      <HeaderBranchTitle varPageTitle={varClassChildrenInfo.clc_ev_idx === 0?'MDT 발달 진도표 생성':'MDT 발달 진도표 수정'}/>
      <div className="vh-content-body">
        <div className="ct-add-wrap">
          <div className="center-wrap">
            <div className="mdt-info">
							<div className="line">
								<div className="name">{varClassChildrenInfo.ch_name} {PassedMonths(varClassChildrenInfo.ch_birthday)}개월</div>
								<div>{ChangeSimpleDateString(varClassChildrenInfo.ch_birthday)} ({GetChildrenState(varClassChildrenInfo.ch_status)})</div>
							</div>
							<ul>
								<li>
									<p>학기명</p>
									<div>{varClassChildrenInfo.sm_name}</div>
								</li>
								<li>
									<p>클래스</p>
									<div>{varClassChildrenInfo.cl_name}</div>
								</li>
								<li>
									<p>차수</p>
									<div>{varClassChildrenInfo.clc_cnts}/{varClassChildrenInfo.cl_studys}</div>
								</li>
							</ul>
						</div>
            {/* 발달영역평가선택 */}
						<div className="select-wrap">
							<label>평가항목</label>
							<select name="mama_index" value={varStudyIndex} onChange={e=>onChangeStudyHandler(e)}>
                <option value={0}>평가항목 선택</option>
                {varStudyList.map((studys,i)=>(
                  <option key={'studys_'+i} value={studys.vt_idx}>{studys.vt_name}개월 MDT</option>
                ))}
							</select>
						</div>
            
            {varSelectStudySubjectList.map((subjects,i)=>(
              <div key={'subjects_'+i} className="mdt-chk-wrap">
                <p className="con-tit">발달영역 {subjects.vts_name}</p>
                {subjects.checks.map((checks,j)=>(
                  <EvaluationOptions key={'checks_'+subjects.vts_idx+'_'+j} varIndex={subjects.vts_idx} varCheckData={checks} onChangeOptionHandler={onChangeOptionHandler}/>
                ))}
              </div>
            ))}
            
            <div className="form-contoller bt-btn">
							<Link to={'/Branch/AnalysisSet'} className="form-contoller-btn btn-no" style={{width:"48%"}}>취소</Link>
							<button  className="form-contoller-btn btn-yes" onClick={e=>onUpdateMamMonteHandler(e)}>확인</button>
						</div>
          </div>
        </div>
      </div>
    </div>	
  );
}
export default MamaMonteDetail;